export default __webpack_public_path__ + "static/media/logo-pdf.e3d4dcd6.svg";